import { createFeatureSelector, createSelector } from '@ngrx/store';
import { User } from '@core/objects/user';
import { UserRequest } from '@core/objects/user-request';
import { HttpStatus } from '@core/classes/http-status.class';
import { HttpRequestStatus } from '@core/classes/http-request-status.class';

import { SeatSetting } from '@core/objects/seat';
import { Settings } from '../settings.state';

export enum SettingsUserSeatStatus {
    USER_SEAT_FREE = 0, // seat is free
    USER_SEAT_ASSIGNED = 1, // user is in this seat
    USER_SEAT_PENDING = 2 //invitation sent
}

export class InvitationHttpStatus extends HttpStatus {
	static readonly INITIAL = -1; // new status for when any invitation was sent
}

export class SettingsUsersStatus {
    list: HttpStatus = new HttpStatus();
    seatsList: HttpStatus = new HttpStatus();
    addInvite: HttpRequestStatus = new HttpRequestStatus();
    delInvite: HttpRequestStatus = new HttpRequestStatus();
    delUser: HttpRequestStatus = new HttpRequestStatus();
};

export interface SettingsUsers {
    status: SettingsUsersStatus;
    users: Array<User>;
    // invitations: Array<UserRequest>;
    seats: Array<SeatSetting>;
}

export const initialState: SettingsUsers = {
    status: new SettingsUsersStatus,
    users: [],
    seats: []
};

const settingsFeatureSelector = createFeatureSelector('settings');

const settingsUsersFeatureSelector = createSelector(
    settingsFeatureSelector,
    (state: Settings) => state.users
);

// Selectors
export const usersGetAllUsersSelector = createSelector(
    settingsUsersFeatureSelector,
    (state: SettingsUsers) => state.users
);

export const usersGetAllSeatsSelector = createSelector(
    settingsUsersFeatureSelector,
    (state: SettingsUsers) => state.seats
);

// Status
export const usersStatusListSelector = createSelector(
    settingsUsersFeatureSelector,
    (state: SettingsUsers) => state.status.list
);

export const usersStatusSeatsListSelector = createSelector(
    settingsUsersFeatureSelector,
    (state: SettingsUsers) => state.status.seatsList
);

export const usersStatusAddInviteSelector = createSelector(
    settingsUsersFeatureSelector,
    (state: SettingsUsers) => state.status.addInvite
);

export const usersStatusDelInviteSelector = createSelector(
    settingsUsersFeatureSelector,
    (state: SettingsUsers) => state.status.delInvite
);

export const usersStatusDelUserSelector = createSelector(
    settingsUsersFeatureSelector,
    (state: SettingsUsers) => state.status.delUser
);
